/* eslint-disable @typescript-eslint/no-empty-function */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Link, mergeStyleSets, MessageBar, PrimaryButton, TextField, DefaultButton, Stack } from '@fluentui/react';
import { Constants } from '@shared/utils/constants';
import * as PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { AppReviewCommentItemToolbar } from './appReviewCommentItemToolbar';
const BUTTON_SPACING = 10;
const appReviewCommentComposerStyles = mergeStyleSets({
    commentTextArea: {
        marginBottom: '10px'
    },
    submitButton: {
        marginLeft: `${BUTTON_SPACING / 2} !important`
    },
    commentToolbar: [
        'ms-hiddenLgUp',
        {
            marginRight: BUTTON_SPACING / 2
        }
    ]
});
const tokenDef = {
    childrenGap: BUTTON_SPACING
};
export function AppReviewItemCommentComposer({ signedIn = true, openSignInModal = ()=>{}, onSubmit, initialContent = '', editMode = false, onCloseEdit = ()=>{}, onChange = ()=>{}, onDeleteToggle = ()=>{}, onEditToggle = ()=>{} }, context) {
    const [isDisabled, setIsDisabled] = useState(false);
    const [isShowContentLengthError, setIsShowContentLengthError] = useState(false);
    const isContentValid = (content)=>{
        if (content) {
            return content.length > 0 && content.length <= Constants.Reviews.MaxCommentComposeLength;
        }
        return false;
    };
    useEffect(()=>{
        setIsDisabled(!isContentValid(initialContent));
        setIsShowContentLengthError(false);
    }, [
        initialContent
    ]);
    if (!signedIn) {
        return /*#__PURE__*/ _jsxs(MessageBar, {
            children: [
                context.loc('ReviewItem_CommentSection_Unauthenticated_Compose_Info_SignIn_Description', 'To post comments please '),
                /*#__PURE__*/ _jsx(Link, {
                    onClick: openSignInModal,
                    children: context.loc('ReviewItem_CommentSection_Unauthenticated_Compose_Info_SignIn_Link', 'sign in.')
                })
            ]
        });
    } else {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(TextField, {
                    ariaLabel: context.loc('ReviewItem_CommentSection_Compose_TextBox_Aria_Label', 'Review comment text box'),
                    multiline: true,
                    resizable: false,
                    value: initialContent,
                    maxLength: Constants.Reviews.MaxCommentComposeLength,
                    className: appReviewCommentComposerStyles.commentTextArea,
                    onChange: (e, value)=>{
                        onChange(value);
                        // If the content length warning is showing and the user reduced the content length, hide the warning
                        if (isShowContentLengthError && value.length < Constants.Reviews.MaxCommentComposeLength) {
                            setIsShowContentLengthError(false);
                        }
                    },
                    onKeyDown: ()=>{
                        setIsShowContentLengthError(initialContent.length >= Constants.Reviews.MaxCommentComposeLength);
                    },
                    errorMessage: isShowContentLengthError && context.locParams('ReviewItem_CommentSection_Compose_LongContent_Warning', [
                        Constants.Reviews.MaxCommentComposeLength.toString()
                    ], 'You can enter a comment with a maximum of {0} characters') || null
                }),
                /*#__PURE__*/ _jsxs(Stack, {
                    horizontal: true,
                    wrap: true,
                    tokens: tokenDef,
                    children: [
                        editMode && /*#__PURE__*/ _jsx(AppReviewCommentItemToolbar, {
                            className: appReviewCommentComposerStyles.commentToolbar,
                            onDeleteToggle: onDeleteToggle,
                            onEditToggle: onEditToggle,
                            isEditing: true
                        }),
                        /*#__PURE__*/ _jsx(PrimaryButton, {
                            className: appReviewCommentComposerStyles.submitButton,
                            text: context.loc(!editMode ? 'ReviewItem_CommentSection_Compose_Post_Button_Label' : 'ReviewItem_CommentSection_Compose_Edit_Button_Label'),
                            onClick: onSubmit,
                            allowDisabledFocus: true,
                            disabled: isDisabled
                        }),
                        editMode && /*#__PURE__*/ _jsx(DefaultButton, {
                            text: context.loc('ReviewItem_CommentSection_Compose_Edit_Discard_Button_Label'),
                            onClick: onCloseEdit,
                            allowDisabledFocus: true
                        })
                    ]
                })
            ]
        });
    }
}
AppReviewItemCommentComposer.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
